import * as types from '../mutation-types';
import UserNotificationSettings from '../../api/userNotificationSettings';

const state = {
  record: {},
  uiFlags: {
    isFetching: false,
    isUpdating: false,
  },
};

export const getters = {
  getUIFlags($state) {
    return $state.uiFlags;
  },
  getSelectedEmailFlags: $state => {
    return $state.record.selected_email_flags;
  },
  getSelectedPushFlags: $state => {
    return $state.record.selected_push_flags;
  },
  getSelectedWhatsappFlags: $state => {
    return $state.record.selected_whatsapp_flags;
  },
  // Existe um número de WhatsApp só da equipe? Sem ele, o canal WhatsApp não
  // aparece: aviso pelo número do escritório foi proibido (23/09/2026).
  getWhatsappDaEquipe: $state => {
    return !!$state.record.whatsapp_da_equipe;
  },
  getWhatsappNumber: $state => {
    return $state.record.whatsapp_number;
  },
  getFatalDeadlineScope: $state => {
    return $state.record.fatal_deadline_scope;
  },
};

// A tela salva em pedaços — a matriz de e-mail e sino num lugar, o cartão de
// prazo fatal noutro. Só vai para a API o que a tela mandou: o back não mexe
// no que não veio, então salvar o celular não apaga os canais de e-mail.
const CAMPOS = {
  selectedEmailFlags: 'selected_email_flags',
  selectedPushFlags: 'selected_push_flags',
  selectedWhatsappFlags: 'selected_whatsapp_flags',
  whatsappNumber: 'whatsapp_number',
  fatalDeadlineScope: 'fatal_deadline_scope',
};

export const actions = {
  get: async ({ commit }) => {
    commit(types.default.SET_USER_NOTIFICATION_UI_FLAG, { isFetching: true });
    try {
      const response = await UserNotificationSettings.get();
      commit(types.default.SET_USER_NOTIFICATION, response.data);
      commit(types.default.SET_USER_NOTIFICATION_UI_FLAG, {
        isFetching: false,
      });
    } catch (error) {
      commit(types.default.SET_USER_NOTIFICATION_UI_FLAG, {
        isFetching: false,
      });
      // Repassa: a tela precisa saber a diferença entre "não marquei nada" e
      // "não consegui carregar" — e é nela que moram os avisos de prazo fatal.
      throw error;
    }
  },

  update: async ({ commit }, mudanca) => {
    commit(types.default.SET_USER_NOTIFICATION_UI_FLAG, { isUpdating: true });
    try {
      const notificationSettings = Object.entries(CAMPOS).reduce(
        (payload, [campo, chaveDaApi]) =>
          mudanca[campo] === undefined
            ? payload
            : { ...payload, [chaveDaApi]: mudanca[campo] },
        {}
      );
      const response = await UserNotificationSettings.update({
        notification_settings: notificationSettings,
      });
      commit(types.default.SET_USER_NOTIFICATION, response.data);
      commit(types.default.SET_USER_NOTIFICATION_UI_FLAG, {
        isUpdating: false,
      });
    } catch (error) {
      commit(types.default.SET_USER_NOTIFICATION_UI_FLAG, {
        isUpdating: false,
      });
      throw error;
    }
  },
};

export const mutations = {
  [types.default.SET_USER_NOTIFICATION_UI_FLAG]($state, data) {
    $state.uiFlags = {
      ...$state.uiFlags,
      ...data,
    };
  },
  [types.default.SET_USER_NOTIFICATION]: ($state, data) => {
    $state.record = data;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
